module.exports = __webpack_public_path__ + "static/img/lot.a5f25fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/lot.png
// module id = eE8f
// module chunks = 0